// Versão do app - gerado automaticamente
export const APP_VERSION = '5.33'
export const BUILD_DATE = '08/05/2026, 15:33'
